import React, { useEffect, useState } from 'react';
import { Chip, Stack, Avatar, Typography, Button, CircularProgress } from '@mui/material';
import { useProperty } from '@olympeio/core';
import { stringAvatar } from '../section_sf/Utils.js';
import { getIcon } from '../shared/utils/_icons.jsx';
import { Auth, CloudObject, User, Config } from 'olympe';
import IconButton from "@mui/material/IconButton";

export const Collab = (props) => {
    const [mergeList, setMergeList] = useState([]);

    //List of owners and members of a group
    const ownerListCollaborators = useProperty(props.context, 'ownerListCollaborators');
    const memberListCollaborators = useProperty(props.context, 'memberListCollaborators');

    const loggedInUserMail = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);

    useEffect(() => {
        //sorted owners and members of a group
        const sortedOwners = ownerListCollaborators ? ownerListCollaborators.sort((a, b) => a.getDisplayName().localeCompare(b.getDisplayName())) : [];
        const sortedMembers = memberListCollaborators ? memberListCollaborators.sort((a, b) => a.getDisplayName().localeCompare(b.getDisplayName())) : [];

        //Filter to remove the duplication for those who are in members and owners list both
        const groupMembers = sortedMembers.filter((member) => {
            return (
                !sortedOwners.some((owner) => {
                    return owner.getId() === member.getId()
                })
            )
        })

        const memberList = groupMembers.map((member) => {
            return {
                owner: false,
                value: member
            }
        })

        const ownerList = sortedOwners.map((owner) => {
            return {
                owner: true,
                value: owner
            }
        })
        //combine list of owners and members after removing the duplication
        setMergeList([...ownerList, ...memberList]);
    }, [ownerListCollaborators, memberListCollaborators]);

    const handleAddCollaborator = () => {
        props.context.trigger('Add Collaborators');
    }
    const isLoggedInOwner = mergeList.find(obj => obj.value.getMail() === loggedInUserMail && obj.owner === true);

    const handleDeleteCollaborator = (id, displayName) => {
        const selectedMember = {
            id, displayName
        }
        props.context.set("selectedMemberToRemove", selectedMember);
        props.context.trigger('Delete User');
    }

    return (
        <div>
            {props.groupID === null ? <Typography variant='body1' sx={{ color: '#8c9394' }}>
                Group does not exist,please create a group
                     </Typography> :
                <div>
                    {mergeList && mergeList.length > 0 ? <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant='body1' sx={{ color: '#8c9394', marginBottom: 3, marginTop: 1 }}>
                            Collaborators have full access to edit materials,tasks and chat.
                     </Typography>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '10px', columnGap: '80px' }}>
                            {mergeList.map((member, index) => {
                                return (
                                  Config.getParameter(
                                    'techUserObjectUPN'
                                  ).localeCompare(
                                    member.value.getMail(),
                                    undefined,
                                    { sensitivity: 'base' }
                                  ) !== 0 && (
                                    <div
                                      key={index}
                                      style={{
                                        display: 'flex',
                                        marginRight: 20,
                                      }}>
                                      <div style={{ flex: 3 }}>
                                        <Stack direction='row' spacing={2}>
                                          <Avatar
                                            {...stringAvatar(
                                              member.value.getDisplayName()
                                            )}
                                          />
                                          <div
                                            style={{
                                              display: 'flex',
                                              flexDirection: 'column',
                                              marginBottom: 10,
                                            }}>
                                            <Typography
                                              variant='body1'
                                              sx={{
                                                fontWeight: '800',
                                                color: '#828a8c',
                                              }}>
                                              {member.value.getDisplayName()}
                                            </Typography>
                                            <Typography
                                              variant='body1'
                                              sx={{ color: '#6f787a' }}>
                                              {member.value.getMail()}
                                            </Typography>
                                          </div>
                                        </Stack>
                                      </div>
                                      <div style={{ flex: 1 }}>
                                        {member.owner ? (
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'flex-end',
                                              alignItems: 'center',
                                            }}>
                                            <Chip
                                              label={'Owner'}
                                              variant='outlined'
                                              sx={{
                                                color: '#16a4eb',
                                                fontWeight: 800,
                                                borderColor: '#16a4eb',
                                                borderWidth: 2,
                                                marginRight: 1,
                                              }}
                                              size='large'></Chip>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'flex-end',
                                              alignItems: 'center',
                                            }}>
                                            <IconButton
                                              aria-label='delete'
                                              onClick={() =>
                                                handleDeleteCollaborator(
                                                  member.value.getId(),
                                                  member.value.getDisplayName()
                                                )
                                              }
                                              size='large'
                                              disabled={
                                                isLoggedInOwner !== undefined
                                                  ? false
                                                  : true
                                              }>
                                              {getIcon('Delete')}
                                            </IconButton>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )
                                );
                            })
                            }
                        </div>
                    </div> : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
                        <CircularProgress style={{ width: '3%', height: '3%', margin: 'auto' }} />
                    </div>
                    }</div>
            }
            { mergeList.length > 0 && props.groupID!==null &&<div >
                <Button
                    variant='contained'
                    style={{ float: 'right', marginRight: 20 }}
                    startIcon={getIcon('AddIcon')}
                    onClick={handleAddCollaborator}
                    sx={{ padding: '12px 10px !important', textTransform: 'none !important' }}
                >Add Collaborator
                </Button>
            </div>}
        </div>
    )
}
